export const BUTTON_TYPES = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    TERTIARY: 'TERTIARY',
    REGISTER: 'TERTIARY',
    LOGIN: 'TERTIARY'
}